module.exports = __webpack_public_path__ + "img/LinkGreen.1b283277.svg";